import { capitalize } from "lodash";

export const formatNounOverrideText = (lowerCase: boolean, text: string) => {
  const capitalizePhrase = (phrase: string) => {
    return phrase
      .toLowerCase()
      .split(" ")
      .map((word) => capitalize(word))
      .join(" ");
  };

  return lowerCase ? text.toLowerCase() : capitalizePhrase(text);
};

export const formatNounOverride = (
  lowerCase: boolean,
  singular: string,
  plural: string
) => {
  return {
    singular: formatNounOverrideText(lowerCase, singular),
    plural: formatNounOverrideText(lowerCase, plural),
  };
};
